var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{ref:_vm.msgData.messageUid,staticClass:"border-radius-16 mx-1",attrs:{"width":"320","height":"auto","controls":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }